import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  phoneNumber: string;
}

const codeRequestToPhoneOrEmailMutation = () => useMutation({
  mutationKey: ['codeRequestToPhoneOrEmail'],
  mutationFn: (body: Props) => agent.getClient().post('auth/phone-number', body),
});

export default codeRequestToPhoneOrEmailMutation;
